import React, { useState, useEffect, useCallback } from "react";
import styles from "./Fortress.module.css";
import ProgressBar from "../components/ProgressBar";
import NavPanel from "../components/NavPanel";
import TapArea from "../components/TapArea";
import NBLogo from "../components/NBLogo";
import Popup from "../components/Popup";

import { useNavigate } from "react-router-dom";

const products = [
  { name: "Product 1", img_main: 'prodigy_assets/1_main.png', image: "prodigy_assets/1_thumb.png", desc: 'White with Metallic Gold', 
    dots: [ 
      {x: 165, y: 28, image: 'prodigy_assets/1_1.png', feature: 'Intelligently crafted', details: 'On the football field, speed isn’t always a straight line. The Prodigy features a lightweight plate with a T-shaped stud configuration, designed to provide multi-directional traction during the quick cuts and explosive acceleration demanded by skill positions.'}, 
      {x: 175, y: 116, image: 'prodigy_assets/1_2.png', feature: 'Superior fit', details: 'There are countless split-second decisions that occur on the gridiron. Whether your cleats fit correctly shouldn’t be one of them. A multi-layer upper is designed to provide a glove-like feel, for support and stability. Hybrid collar construction provides a comfortable lockdown fit around the heel.'},
      {x: 315, y: 79, image: 'prodigy_assets/1_3.png', feature: 'FuelCell insert', details: 'A sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness when you’re hitting the hole or taking off on a vertical route outside the hashmarks - the moments when speed matters most.'} ]},
  { name: "Product 2", img_main: 'prodigy_assets/2_main.png', image: "prodigy_assets/2_thumb.png", desc: 'White with Silver Metallic',
    dots: [
      {x: 165, y: 28, image: 'prodigy_assets/2_1.png', feature: 'Intelligently crafted', details: 'On the football field, speed isn’t always a straight line. The Prodigy features a lightweight plate with a T-shaped stud configuration, designed to provide multi-directional traction during the quick cuts and explosive acceleration demanded by skill positions.'}, 
      {x: 175, y: 116, image: 'prodigy_assets/2_2.png', feature: 'Superior fit', details: 'There are countless split-second decisions that occur on the gridiron. Whether your cleats fit correctly shouldn’t be one of them. A multi-layer upper is designed to provide a glove-like feel, for support and stability. Hybrid collar construction provides a comfortable lockdown fit around the heel.'},
      {x: 320, y: 79, image: 'prodigy_assets/2_3.png', feature: 'FuelCell insert', details: 'A sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness when you’re hitting the hole or taking off on a vertical route outside the hashmarks - the moments when speed matters most.'} ]},
  { name: "Product 3", img_main: 'prodigy_assets/3_main.png', image: "prodigy_assets/3_thumb.png", desc: ' Black with Magnet and Shadow Gray' ,
    dots: [
      {x: 165, y: 28, image: 'prodigy_assets/3_1.png', feature: 'Intelligently crafted', details: 'On the football field, speed isn’t always a straight line. The Prodigy features a lightweight plate with a T-shaped stud configuration, designed to provide multi-directional traction during the quick cuts and explosive acceleration demanded by skill positions.'}, 
      {x: 175, y: 116, image: 'prodigy_assets/3_2.png', feature: 'Superior fit', details: 'There are countless split-second decisions that occur on the gridiron. Whether your cleats fit correctly shouldn’t be one of them. A multi-layer upper is designed to provide a glove-like feel, for support and stability. Hybrid collar construction provides a comfortable lockdown fit around the heel.'},
      {x: 320, y: 79, image: 'prodigy_assets/3_3.png', feature: 'FuelCell insert', details: 'A sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness when you’re hitting the hole or taking off on a vertical route outside the hashmarks - the moments when speed matters most.'} ]},
  { name: "Product 4", img_main: 'prodigy_assets/4_main.png', image: "prodigy_assets/4_thumb.png", desc: 'Raincloud with Slate Grey and Silver Metallic',
    dots: [
      {x: 165, y: 28, image: 'prodigy_assets/4_1.png', feature: 'Intelligently crafted', details: 'On the football field, speed isn’t always a straight line. The Prodigy features a lightweight plate with a T-shaped stud configuration, designed to provide multi-directional traction during the quick cuts and explosive acceleration demanded by skill positions.'}, 
      {x: 175, y: 116, image: 'prodigy_assets/4_2.png', feature: 'Superior fit', details: 'There are countless split-second decisions that occur on the gridiron. Whether your cleats fit correctly shouldn’t be one of them. A multi-layer upper is designed to provide a glove-like feel, for support and stability. Hybrid collar construction provides a comfortable lockdown fit around the heel.'},
      {x: 320, y: 79, image: 'prodigy_assets/4_3.png', feature: 'FuelCell insert', details: 'A sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness when you’re hitting the hole or taking off on a vertical route outside the hashmarks - the moments when speed matters most.'} ]},
  { name: "Product 5", img_main: 'prodigy_assets/5_main.png', image: "prodigy_assets/5_thumb.png", desc: 'Black Cement with Electric Jade and Passion Fruit',  
    dots:[
      {x: 165, y: 28, image: 'prodigy_assets/5_1.png', feature: 'Intelligently crafted', details: 'On the football field, speed isn’t always a straight line. The Prodigy features a lightweight plate with a T-shaped stud configuration, designed to provide multi-directional traction during the quick cuts and explosive acceleration demanded by skill positions.'}, 
      {x: 175, y: 116, image: 'prodigy_assets/5_2.png', feature: 'Superior fit', details: 'There are countless split-second decisions that occur on the gridiron. Whether your cleats fit correctly shouldn’t be one of them. A multi-layer upper is designed to provide a glove-like feel, for support and stability. Hybrid collar construction provides a comfortable lockdown fit around the heel.'},
      {x: 320, y: 79, image: 'prodigy_assets/5_3.png', feature: 'FuelCell insert', details: 'A sockliner insert utilizes the same technology as our elite racing shoes. FuelCell’s propulsive feeling of energy return provides an extra dimension of underfoot responsiveness when you’re hitting the hole or taking off on a vertical route outside the hashmarks - the moments when speed matters most.'} ]},
];


const Prodigy = () => {
  const [active, setActive] = useState(0);
  const [fadeIn, setFadeIn] = useState(false);
  const [featureNumber, setFeatureNumber] = useState();
  const activeProduct = products[active]
  const navigate = useNavigate();
  
  const nbProductPage = "Redirects to product page on New Balance website."
  const nbPage = "Redirects to New Balance website."
  const [popupText, setPopupText] = useState(nbPage)
  const [popupVisible, setPopupVisible] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  const onPreviousPageClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const onNextPageClick = useCallback(() => {
    navigate("/shop-cta");
  }, [navigate]);

  const onClickDot = (id) => {
    if (id == featureNumber) {
      setFeatureNumber(null)
    } else {
      setFeatureNumber(id)
    }    
  }
  
  const renderDots  = () => {
    return(
      (activeProduct.dots || []).map((dot, idx) => (
        ((featureNumber == null) || (featureNumber == idx)) && 
        <div 
          key={`${products[active].name}-dot-${idx}`} 
          style={{ left: `${dot.x}px`, top:  `${featureNumber == null ? dot.y : 190}px` }}
          className={`${styles.redCircle} ${featureNumber == null ? styles.redPulse : '' }`} 
          onClick={() => onClickDot(idx)}>
        </div>    
      ))
    )
  };
  
  const onClickLink =  (link) => {
    umami?.track('Client Link - Prodigy shop', { link: link });
    // window.open(link)
    setPopupText(nbProductPage)
    setPopupVisible(true)
  }

  const onClickLogo = () => {
    const link = 'https://www.newbalance.com'
    umami?.track('Client Link - Prodigy logo', { link: link });

    setPopupText(nbPage)
    setPopupVisible(true)
  }

  return (
    <div className={styles.fortressPage}>
      <NavPanel onClick={onPreviousPageClick} />
      <NavPanel position='right' onClick={onNextPageClick} />
      <ProgressBar current='5' />
      <TapArea style={styles.topLeftNav} onClick={onPreviousPageClick} />
      <TapArea style={styles.bottomLeftNav} onClick={onPreviousPageClick} />

      <TapArea style={styles.topRightNav} onClick={onNextPageClick} />
      <TapArea style={styles.bottomRightNav} onClick={onNextPageClick} />

      <div className={styles.pageHeading}> 
        <NBLogo onClick={onClickLogo }/>
      </div>  
      <div className={styles.productType}>
        Prodigy 
      </div>

      <div className={styles.slogan}> 
        A cleat specifically engineered for skill position players.
      </div> 


      <div className={styles.productListContainer} >
        <div className={styles.detailArea}>
          <div className={`${styles.detailWrapper} ${featureNumber == 1 ? styles.fullWidth : ''}`} >
            <img
              src={products[active].img_main}
              alt={products[active].name}
              className={styles.detailImg}
            />

            { featureNumber != null &&   
              <div className={styles.featureContainer}>
                <img
                  src={activeProduct.dots[featureNumber].image}
                  className={`${styles.detailImg}  ${featureNumber == 1 ? styles.fullWidth : ''} ${styles.featuredImage}`}
                  onClick={() => onClickDot(featureNumber)}
                />
              </div>
            }
            { featureNumber != null &&   
              <div className={`${styles.featureText}`} >
                <div className={styles.featureName}> {activeProduct.dots[featureNumber].feature} </div>
                <div className={styles.featureContent}> {activeProduct.dots[featureNumber].details} </div>
              </div> 
            }
            <div className={styles.dots} >
              { renderDots() }
            </div> 
          </div>
        </div>
        <div className={styles.productList}>
          {products.map((product, idx) => (
            <div
              key={product.name}
              className={idx === active ? `${styles.productItem} ${styles.active}` : styles.productItem}
              onClick={() => { setActive(idx) ; setFeatureNumber(null) }}
            >
              <img
                src={product.image}
                alt={product.name}
                className={styles.productThumb}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.productDesc}> 
        {products[active].desc}
      </div>

      <a onClick={() => onClickLink('https://www.newbalance.com/men/shoes/football/?prefn1=seriesNumber&prefv1=Prodigy&ICID=CLP_A_PGP_SHOP_PRODIGY_NB4143_MWK') }
        className={styles.btnShop}>        
        Shop
      </a>

      <div className={`${styles.text} ${fadeIn ? styles.fadeIn : ""}`}>Because the game deserves better.</div>
      { featureNumber != null &&   
        <div className={styles.overlay} onClick={() => setFeatureNumber(null)}></div>
      }
      <Popup visible={popupVisible} onHide={() => setPopupVisible(false)}>
        {popupText}
      </Popup>
    </div>
  );
};

export default Prodigy;